module.exports = __webpack_public_path__ + "img/332.661b032d.svg";